/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import { respGridUtil } from '@marriott/mi-headless-utils';
import {
  EditableHTLWrapper,
  CardLayered,
  CardVertical,
  AccordionContainerEnhanced,
  IconBlock,
  RichText,
  Hero,
  BannerLayered,
  NavigationContainerWrapper,
} from '@marriott/mi-common-static-components';
import {
  HeaderTextCtaEditable,
  CardHorizontalFeature,
  CardCarouselContainer,
  SignatureCarousel,
  WysiwygTextEditable,
  ContactUsFooterEditable,
  QuoteEditable,
  LinkBanner,
  LogoBlockEditable,
  TopNavigationEditable,
  CinemographHeroEditable,
  OneUpHighlightEditable,
  BrandRibbonEditable,
  BreadcrumbEditable,
  ButtonBannerEditable,
  CarouselGallery,
  TabEditableComponent,
  RoundUpEditable,
  MbopOffers,
  SearchFormEditable,
  HubHeroBasicEditable,
  LuxurySuitesEditable,
  SearchResultsComponentEditable,
  DynamicPropertyCardLuxury,
  PhotoEssayEditable,
} from '@marriott/mi-luxury-components';
import {
  OBannerFeature,
  OCardLayeredStandard,
  OCardStandard,
  OCardCarouselCombo,
  OEditorialHighlight,
  OTabContainer,
  OCarouselTriptych,
  OCardCarousel,
} from '@marriott/mi-designsystem-components';
import { FlyoutDrawer } from '@marriott/mi-book-components';
import { AccountContainerEditable, SignInEditable, SignInContentBlockEditable } from '@marriott/mi-account-components';
import { Footer } from '@marriott/mi-common-static-components';
import { getAllowedComponentsForNonAuthorMode as getAllowedComponentsForNonAuthorModeUtil } from '@marriott/shared/mi-helper-utils';

export const AEM_REACT_MAPPING = {
  // luxury-spa
  [`mi-aem-luxury-spa/components/content/header-text-cta/v1/header-text-cta`]: HeaderTextCtaEditable,
  ['mi-aem-luxury-spa/components/content/cardcarouselcontainer/v1/cardcarouselcontainer']: CardCarouselContainer,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/signature-carousel/v1/signature-carousel`]:
    SignatureCarousel,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/wysiwyg/v1/wysiwyg`]: WysiwygTextEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/footer/v1/footer`]: ContactUsFooterEditable,
  ['mi-aem-luxury-spa/components/content/quote/v1/quote']: QuoteEditable,
  ['mi-aem-common-spa/components/content/tabcontainer']: TabEditableComponent,
  ['mi-aem-luxury-spa/components/content/cinemograph-hero/v1/cinemograph-hero']: CinemographHeroEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/one-up-highlight/v1/one-up-highlight`]:
    OneUpHighlightEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/brand-ribbon/v1/brand-ribbon`]: BrandRibbonEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/breadcrumb/v1/breadcrumb`]: BreadcrumbEditable,
  [`${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/button-banner/v1/button-banner`]: ButtonBannerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/round-up/v1/round-up`]: RoundUpEditable,
  [`mi-aem-luxury-spa/components/content/baselinesearchform/v1/baselinesearchform`]: SearchFormEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hub-hero-basic/v1/hub-hero-basic`]: HubHeroBasicEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/suites-catalog/v1/suites-catalog`]: LuxurySuitesEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/map-clusters/v1/map-clusters`]:
    SearchResultsComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/photo-essay/v1/photo-essay`]: PhotoEssayEditable,

  // common-spa
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-luxury-spa/components/content/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/content/accordioncontainerenhanced`]: AccordionContainerEnhanced,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: LogoBlockEditable,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/carouselgallery`]: CarouselGallery,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`mi-aem-common-spa/components/content/hero`]: Hero,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-common-spa/components/content/globalnav/global-navigation`]: NavigationContainerWrapper,

  //leisure-spa
  [`mi-aem-offers-spa/components/offers-cards`]: MbopOffers,
  [`mi-aem-leisure-spa/components/dynamicpropertycards`]: DynamicPropertyCardLuxury,

  // homepage-spa
  [`mi-aem-homepage-spa/components/content/universal-footer`]: Footer,

  //designsystem-spa
  [`mi-aem-utils/components/content/o-banner-feature`]: OBannerFeature,
  [`mi-aem-utils/components/content/o-card-layered-standard`]: OCardLayeredStandard,
  [`mi-aem-utils/components/content/o-card-standard`]: OCardStandard,
  [`mi-aem-utils/components/content/o-card-carousel-combo`]: OCardCarouselCombo,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/signin`]: SignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
  [`mi-aem-utils/components/content/luxury/o-editorial-highlight`]: OEditorialHighlight,
  [`mi-aem-utils/components/content/o-tab-container`]: OTabContainer,
  [`mi-aem-utils/components/content/o-carousel-triptych`]: OCarouselTriptych,
  [`mi-aem-utils/components/content/o-card-carousel`]: OCardCarousel,
};

export const AEM_REACT_TITLE_MAPPING = {
  [`mi-aem-luxury-spa/components/content/header-text-cta/v1/header-text-cta`]: 'Header Text CTA',
  'mi-aem-luxury-spa/components/content/cardcarouselcontainer/v1/cardcarouselcontainer': 'Card Carousel Container',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/signature-carousel/v1/signature-carousel`]:
    'Signature Carousel',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/wysiwyg/v1/wysiwyg`]: 'WYSIWYG Text',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/footer/v1/footer`]: 'Footer',
  'mi-aem-luxury-spa/components/content/quote/v1/quote': 'Quote',
  'mi-aem-common-spa/components/content/tabcontainer': 'Tab Container',
  'mi-aem-luxury-spa/components/content/cinemograph-hero/v1/cinemograph-hero': 'Cinemograph Hero',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/one-up-highlight/v1/one-up-highlight`]: '1Up Highlight',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/brand-ribbon/v1/brand-ribbon`]: 'Brand Ribbon',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/breadcrumb/v1/breadcrumb`]: 'Breadcrumb',
  [`${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/button-banner/v1/button-banner`]: 'Button Banner',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/round-up/v1/round-up`]: 'Round Up',
  'mi-aem-luxury-spa/components/content/baselinesearchform/v1/baselinesearchform': 'Baseline Search Form',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hub-hero-basic/v1/hub-hero-basic`]: 'Hub Hero Basic',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/suites-catalog/v1/suites-catalog`]: 'Suites Display Catalog',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/map-clusters/v1/map-clusters`]: 'Map Clusters',
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/photo-essay/v1/photo-essay`]: 'Photo Essay',
  'mi-aem-common-spa/components/content/linkbanner': 'Link Banner',
  'mi-aem-common-spa/components/content/cardlayered': 'Card Layered',
  'mi-aem-common-spa/components/content/cardvertical': 'Card Vertical',
  'mi-aem-common-spa/components/content/cardhorizontalfeature': 'Card Horizontal Feature',
  'mi-aem-common-spa/components/experiencefragment': 'Experience Fragment',
  'mi-aem-luxury-spa/components/content/experiencefragment': 'Luxury Experience Fragment',
  'mi-aem-common-spa/components/content/accordioncontainerenhanced': 'Accordion Container-Enhanced',
  'mi-aem-common-spa/components/content/variablecolumncontainer': 'Variable Column Container',
  'mi-aem-common-spa/components/content/iconblock': 'Icon Block',
  'mi-aem-common-spa/components/content/carouselgallery': 'Carousel Gallery',
  'mi-aem-common-spa/components/content/richtext': 'Rich Text',
  'mi-aem-common-spa/components/content/hero': 'Hero',
  'mi-aem-common-spa/components/content/bannerlayered': 'Banner Layered',
  'mi-aem-offers-spa/components/offers-cards': 'Offers Cards Carousel',
  'mi-aem-leisure-spa/components/dynamicpropertycards': 'Dynamic Property Cards',
  'mi-aem-utils/components/content/o-banner-feature': 'Banner Feature',
  'mi-aem-utils/components/content/o-card-layered-standard': 'Card Layered Standard',
  'mi-aem-utils/components/content/o-card-standard': 'Card Standard',
  'mi-aem-utils/components/content/o-card-carousel-combo': 'Card Carousel Combo',
  'mcom-book-spa/components/flyoutcontainer': 'Flyout Container',
  'mi-aem-account/components/content/accountcontainer': 'Account Container',
  'mi-aem-account/components/content/signin': 'Sign In',
  'mi-aem-account/components/content/signincontentblock': 'Sign In Content Block',
  'mi-aem-account/components/content/datapagecomponent': 'Data Page Component',
  'mi-aem-utils/components/content/luxury/o-editorial-highlight': 'Editorial Highlight',
  'mi-aem-utils/components/content/o-tab-container': 'Tab Container',
  'mi-aem-utils/components/content/o-carousel-triptych': 'O Carousel Triptych',
  'mi-aem-homepage-spa/components/content/universal-footer': 'Universal Footer',
  'mi-aem-utils/components/content/o-card-carousel': 'O Card Carousel',
};

export const getAllowedComponentsForNonAuthorMode = model => {
  return getAllowedComponentsForNonAuthorModeUtil(model, AEM_REACT_MAPPING, AEM_REACT_TITLE_MAPPING);
};

export const defineComponentMapping = (
  allowedComponents,
  isAuthorMode,
  pageProps,
  languageSelectorModal,
  featureFlagLogo,
  featureFlagLegacyNav
) => {
  const logger = global.loggerInstance?.('defineComponentMapping');
  const log = logger?.log || (() => {});
  const logError = logger?.error || (() => {});

  try {
    // common-spa
    MapTo(`mi-aem-common-spa/components/content/cardlayered`)(
      props => <CardLayered {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'CardLayered',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/tabcontainer`)(
      props => (
        <TabEditableComponent
          {...props}
          isAuthorMode={isAuthorMode}
          allowedComponents={allowedComponents}
          componentPath="mi-luxury-components"
        />
      ),
      {
        emptyLabel: 'TabContainer',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-luxury-spa/components/content/baselinesearchform/v1/baselinesearchform`)(
      props => (
        <SearchFormEditable
          {...props}
          isAuthorMode={isAuthorMode}
          isPositionedExternally={false}
          currentLocale={pageProps?.currentLocale}
        />
      ),
      {
        emptyLabel: 'SearchForm',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/suites-catalog/v1/suites-catalog`)(
      props => <LuxurySuitesEditable {...props} isAuthorMode={isAuthorMode} featureFlagLogo={featureFlagLogo} />,
      {
        emptyLabel: 'LuxurySuitesEditable',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/map-clusters/v1/map-clusters`)(
      props => (
        <SearchResultsComponentEditable {...props} isAuthorMode={isAuthorMode} featureFlagLogo={featureFlagLogo} />
      ),
      {
        emptyLabel: 'SearchResultsComponentEditable',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/accordioncontainerenhanced`)(
      props => (
        <AccordionContainerEnhanced
          {...props}
          isAuthorMode={isAuthorMode}
          allowedComponents={allowedComponents}
          componentPath="mi-luxury-components"
        />
      ),
      {
        emptyLabel: 'AccordionContainerEnhanced',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(
      props => <CardHorizontalFeature {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'CardHorizontalFeature',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/cardvertical`)(
      props => <CardVertical {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'CardVertical',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(
      props => (
        <LogoBlockEditable
          {...props}
          isAuthorMode={isAuthorMode}
          allowedComponents={allowedComponents}
          componentPath="mi-luxury-components"
        />
      ),
      {
        emptyLabel: 'Logo Block Editable',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/iconblock`)(props => <IconBlock {...props} />, {
      emptyLabel: 'Icon Block',
      isEmpty: false,
    });

    MapTo(`mi-aem-common-spa/components/content/hero`)(props => <Hero {...props} />, {
      emptyLabel: 'Legacy Hero',
      isEmpty: false,
    });

    MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(props => <BannerLayered {...props} />, {
      emptyLabel: 'Legacy Banner Layered',
      isEmpty: false,
    });

    MapTo(`mi-aem-common-spa/components/content/globalnav/global-navigation`)(props => (
      <NavigationContainerWrapper
        {...props}
        isAuthorMode={isAuthorMode}
        featureFlagLogo={featureFlagLogo}
        featureFlagLegacyNav={featureFlagLegacyNav}
      />
    ));

    const ExperienceFragmentVariationConfig = {
      emptyLabel: 'Experience Fragment',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };

    MapTo('mi-aem-common-spa/components/experiencefragment')(props => {
      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
        />
      );
    }, ExperienceFragmentVariationConfig);

    MapTo('mi-aem-luxury-spa/components/content/experiencefragment')(props => {
      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
        />
      );
    }, ExperienceFragmentVariationConfig);

    // luxury-spa
    MapTo(`mi-aem-luxury-spa/components/content/header-text-cta/v1/header-text-cta`)(
      props => <HeaderTextCtaEditable {...props} isAuthorMode={isAuthorMode} featureFlagLogo={featureFlagLogo} />,
      {
        emptyLabel: 'LuxuryHeaderTextCta',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/linkbanner`)(
      props => <LinkBanner {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'LinkBanner',
        isEmpty: false,
      }
    );
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/signature-carousel/v1/signature-carousel`)(
      props => <SignatureCarousel {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'SignatureCarousel',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-luxury-spa/components/content/cardcarouselcontainer/v1/cardcarouselcontainer`)(
      props => <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
      {
        emptyLabel: 'LuxuryCarousel',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-luxury-spa/components/content/wysiwyg/v1/wysiwyg`)(
      props => <WysiwygTextEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'WysiwygText',
        isEmpty: false,
      }
    );
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/footer/v1/footer`)(
      props => (
        <ContactUsFooterEditable {...props} isAuthorMode={isAuthorMode} languageSelectorModal={languageSelectorModal} />
      ),
      {
        emptyLabel: 'ContactUsFooter',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-luxury-spa/components/content/quote/v1/quote`)(
      props => <QuoteEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'LuxuryQuote',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-luxury-spa/components/content/top-navigation/v1/top-navigation`)(
      props => (
        <TopNavigationEditable
          {...props}
          isAuthorMode={isAuthorMode}
          languageSelectorModal={languageSelectorModal}
          featureFlagLogo={featureFlagLogo}
        />
      ),
      {
        emptyLabel: 'TopNavigation',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-luxury-spa/components/content/one-up-highlight/v1/one-up-highlight`)(
      props => <OneUpHighlightEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'LuxuryOneUpHighlight',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-luxury-spa/components/content/cinemograph-hero/v1/cinemograph-hero`)(
      props => <CinemographHeroEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'CinemographHero',
        isEmpty: false,
      }
    );
    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/breadcrumb/v1/breadcrumb`)(
      props => <BreadcrumbEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'LuxuryBreadcrumb',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/brand-ribbon/v1/brand-ribbon`)(
      props => <BrandRibbonEditable {...props} isAuthorMode={isAuthorMode} featureFlagLogo={featureFlagLogo} />,
      {
        emptyLabel: 'BrandRibbon',
        isEmpty: false,
      }
    );

    MapTo(`${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/button-banner/v1/button-banner`)(
      props => <ButtonBannerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'ButtonBanner',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/carouselgallery`)(
      props => <CarouselGallery {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'CarouselGalleryTriptych',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/round-up/v1/round-up`)(
      props => <RoundUpEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'LuxuryRoundUp',
        isEmpty: false,
      }
    );

    MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hub-hero-basic/v1/hub-hero-basic`)(
      props => <HubHeroBasicEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'LuxuryHubHeroBasic',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-luxury-spa/components/content/photo-essay/v1/photo-essay`)(
      props => <PhotoEssayEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'LuxuryPhotoEssay',
        isEmpty: false,
      }
    );

    //leisure-spa

    MapTo(`mi-aem-leisure-spa/components/dynamicpropertycards`)(props => {
      return (
        <DynamicPropertyCardLuxury
          {...props}
          isAuthorMode={isAuthorMode}
          acceptLanguage={pageProps?.headersData['accept-language']}
          requestId={pageProps?.requestId}
          subDirectoryContextPath={pageProps?.model?.subDirectoryContextPath}
          isDTT={pageProps?.isDTT}
        />
      );
    });

    MapTo(`mi-aem-offers-spa/components/offers-cards`)(props => (
      <div className={`m-container-fullbleed ${props?.model?.styleclass ?? ''}`}>
        <MbopOffers
          {...props}
          isAuthorMode={isAuthorMode}
          acceptLanguage={pageProps?.headersData['accept-language']}
          requestId={pageProps?.requestId}
          cookie={pageProps?.headersData['cookie']}
        />
      </div>
    ));

    MapTo(`mi-aem-common-spa/components/content/richtext`)(
      props => <RichText {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'RichText',
        isEmpty: false,
      }
    );

    // homepage-spa
    MapTo('mi-aem-homepage-spa/components/content/universal-footer')(
      props => <Footer {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'Footer',
        isEmpty: false,
      }
    );

    //designsystem-spa
    MapTo(`mi-aem-utils/components/content/o-banner-feature`)(
      props => <OBannerFeature {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'OBannerFeature',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-utils/components/content/o-card-layered-standard`)(
      props => <OCardLayeredStandard {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'OCardLayeredStandard',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-utils/components/content/o-card-standard`)(
      props => <OCardStandard {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'OCardStandard',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-utils/components/content/o-card-carousel-combo`)(
      props => (
        <OCardCarouselCombo {...props} isAuthorMode={isAuthorMode} aemReactComponentMapping={AEM_REACT_MAPPING} />
      ),
      {
        emptyLabel: 'OCardCarouselCombo',
        isEmpty: false,
      }
    );

    MapTo(`mcom-book-spa/components/flyoutcontainer`)(
      props => <FlyoutDrawer {...props.model} {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'FlyoutDrawer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/accountcontainer`)(
      props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'accountcontainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/signin`)(
      props => <SignInEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signin',
      }
    );
    MapTo(`mi-aem-account/components/content/signincontentblock`)(
      props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signincontentblock',
      }
    );
    const DataPageVariationConfig = {
      emptyLabel: 'Data Page',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };
    MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
      const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
      const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
        />
      );
    }, DataPageVariationConfig);

    MapTo(`mi-aem-utils/components/content/luxury/o-editorial-highlight`)(
      props => <OEditorialHighlight {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'OEditorialHighlight',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-utils/components/content/o-tab-container`)(
      props => (
        <OTabContainer
          {...props}
          isAuthorMode={isAuthorMode}
          allowedComponents={allowedComponents}
          aemReactComponentMapping={AEM_REACT_MAPPING}
        />
      ),
      {
        emptyLabel: 'OTabContainer',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-utils/components/content/o-carousel-triptych`)(
      props => <OCarouselTriptych {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'OCarouselTriptych',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-utils/components/content/o-card-carousel`)(
      props => <OCardCarousel {...props} isAuthorMode={isAuthorMode} aemReactComponentMapping={AEM_REACT_MAPPING} />,
      {
        emptyLabel: 'OCardCarousel',
        isEmpty: false,
      }
    );

    const existingMappings = Object.keys(AEM_REACT_MAPPING);

    // Validate allowedComponents before processing
    if (allowedComponents && Array.isArray(allowedComponents)) {
      let successCount = 0;
      let failureCount = 0;

      allowedComponents.forEach((mapping, index) => {
        try {
          // Validate mapping object structure
          if (!mapping || typeof mapping !== 'object') {
            throw new Error(`Invalid mapping object at index ${index}`);
          }

          if (!mapping.path || typeof mapping.path !== 'string') {
            throw new Error(`Invalid or missing path in mapping at index ${index}`);
          }

          const baseModelPath = '/jcr:content/root/responsivegrid/[:items]/responsivegrid';
          const componentPath = mapping.path.split(baseModelPath)[1];

          if (!componentPath) {
            throw new Error(`Unable to extract component path from: ${mapping.path}`);
          }

          if (existingMappings.indexOf(componentPath) === -1) {
            MapTo(componentPath)(EditableHTLWrapper, {
              emptyLabel: mapping.title || 'Component',
              isEmpty: false,
            });
            successCount++;
          } else {
            if (process.env.NODE_ENV === 'development') {
              log('Mapping already exists, skipping:', componentPath);
            }
          }
        } catch (mappingError) {
          failureCount++;
          if (process.env.NODE_ENV === 'development') {
            logError(`Failed to map component at index ${index}:`, {
              error: mappingError.message,
              mapping: mapping,
              stack: mappingError.stack,
            });
          }
          // Continue processing remaining components
        }
      });

      if (process.env.NODE_ENV === 'development') {
        log(
          `Component mapping complete. Success: ${successCount}, Failed: ${failureCount}, Total: ${allowedComponents.length}`
        );
      }
    } else if (process.env.NODE_ENV === 'development') {
      log('No allowed components provided or invalid format');
    }
  } catch (err) {
    // Always log errors regardless of environment - use your server logger, not console
    logError('Critical error in defineComponentMapping:', {
      error: err.message,
      stack: err.stack,
    });
    // Re-throw so the caller (page bootstrap) can decide recovery strategy.
    // Silent failure here means EVERY AEM component renders as blank with zero observability.
    throw err;
  }
};
